import { Calendar, AlertTriangle } from 'lucide-react'

interface PrepareItem {
  id: number
  title: string
  course: string
  date: string
  days_until: number
  urgent: boolean
  message: string
}

interface PrepareSectionProps {
  items: PrepareItem[]
}

export function PrepareSection({ items }: PrepareSectionProps) {
  if (items.length === 0) {
    return null
  }

  // Separate urgent (today/tomorrow) from later
  const urgent = items.filter(i => i.urgent)
  const later = items.filter(i => !i.urgent)

  return (
    <div className="mb-4">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wide flex items-center gap-2 mb-3">
        <Calendar className="w-4 h-4" />
        Upcoming Tests
      </h3>

      <div className="space-y-2">
        {/* Urgent items - prominent styling */}
        {urgent.map((item) => (
          <div
            key={item.id}
            className="p-3 bg-red-900/30 border border-red-500/50 rounded-lg"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <AlertTriangle className="w-4 h-4 text-red-400" />
                <div>
                  <p className="text-sm font-medium text-red-200">{item.title}</p>
                  <p className="text-xs text-red-300/70">{item.course}</p>
                </div>
              </div>
              <span className="text-xs font-bold px-2 py-1 bg-red-500/30 text-red-300 rounded">
                {item.message}
              </span>
            </div>
          </div>
        ))}

        {/* Later items - muted styling */}
        {later.map((item) => (
          <div
            key={item.id}
            className="p-2 bg-yellow-900/10 border border-yellow-500/20 rounded-lg"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-300">{item.title}</p>
                <p className="text-xs text-gray-500">{item.course}</p>
              </div>
              <span className="text-xs px-2 py-0.5 bg-yellow-500/20 text-yellow-400 rounded">
                {item.message}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PrepareSection
